












import { Component, Prop, Mixins } from "vue-property-decorator";
import { i18n } from "@/i18n";

// Mixins
import { WidgetMixin, FieldMixin, GroupMixin, Validator } from "./mixins";

@Component({
  components: {
    WidgetGroup: () => import("@/components/WidgetGroup.vue")
  }
})
export default class WRadioGroup extends Mixins(
  WidgetMixin,
  FieldMixin,
  GroupMixin
) {
  @Prop({ type: Boolean })
  buttons?: boolean;

  @Prop({ type: String, default: "primary" })
  buttonVariant!: string;

  @Prop({ type: Boolean })
  buttonSplit?: boolean;

  @Prop({ type: Array, required: true })
  options!: any[];

  get computedOptions() {
    return this.options.map(o => ({ text: i18n.t(o.text), value: o.value }));
  }

  get computedClasses() {
    return {
      "pt-2": this.horizontal,
      "btn-group-split": this.buttonSplit
    };
  }

  @Validator("required")
  requiredValidator(value: any) {
    return value != null;
  }
}
